import React from 'react';
import Icon from '../../../components/AppIcon';

const UpcomingHolidays = () => {
  const holidays = [
    {
      id: 1,
      name: 'Thanksgiving Day',
      date: '2024-11-28',
      type: 'Federal Holiday',
      description: 'National holiday for thanksgiving celebration'
    },
    {
      id: 2,
      name: 'Christmas Day',
      date: '2024-12-25',
      type: 'Federal Holiday',
      description: 'Christmas celebration - Office closed'
    },
    {
      id: 3,
      name: "New Year\'s Day",
      date: '2025-01-01',
      type: 'Federal Holiday',
      description: 'New Year celebration - Office closed'
    },
    {
      id: 4,
      name: 'Martin Luther King Jr. Day',
      date: '2025-01-20',
      type: 'Federal Holiday',
      description: 'Federal holiday honoring civil rights leader'
    }
  ];

  const announcements = [
    {
      id: 1,
      title: 'Annual Performance Reviews',
      date: '2024-11-15',
      type: 'HR Update',
      priority: 'high',
      content: 'Performance review cycle begins next week. Please prepare your self-assessment documents.'
    },
    {
      id: 2,
      title: 'Holiday Party Planning',
      date: '2024-11-12',
      type: 'Company Event',
      priority: 'medium',
      content: 'Join us for the annual holiday party on December 20th. RSVP required by December 10th.'
    },
    {
      id: 3,
      title: 'Benefits Enrollment Period',
      date: '2024-11-10',
      type: 'Benefits',
      priority: 'high',
      content: 'Open enrollment for 2025 benefits ends November 30th. Review your options in the portal.'
    }
  ];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    const diffTime = date - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Tomorrow';
    if (diffDays > 0) return `In ${diffDays} days`;
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return 'text-error bg-error/10 border-error/20';
      case 'medium':
        return 'text-warning bg-warning/10 border-warning/20';
      case 'low':
        return 'text-success bg-success/10 border-success/20';
      default:
        return 'text-muted-foreground bg-muted border-border';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border card-shadow p-6">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Upcoming Holidays</h3>
        
        <div className="space-y-3">
          {holidays?.map((holiday) => (
            <div key={holiday?.id} className="flex items-center justify-between p-3 bg-primary/5 rounded-lg border border-primary/10">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name="Calendar" size={16} color="var(--color-primary)" />
                </div>
                <div>
                  <h4 className="font-medium text-foreground">{holiday?.name}</h4>
                  <p className="text-xs text-muted-foreground">{holiday?.type}</p>
                </div>
              </div>
              
              <div className="text-right">
                <p className="text-sm font-medium text-primary">
                  {formatDate(holiday?.date)}
                </p>
                <p className="text-xs text-muted-foreground">
                  {new Date(holiday.date)?.toLocaleDateString('en-US', { 
                    month: 'short', 
                    day: 'numeric' 
                  })}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="border-t border-border pt-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Company Announcements</h3>
        
        <div className="space-y-3">
          {announcements?.map((announcement) => (
            <div key={announcement?.id} className="p-4 bg-muted/30 rounded-lg border border-border/50">
              <div className="flex items-start justify-between mb-2">
                <div className="flex items-center space-x-2">
                  <h4 className="font-medium text-foreground">{announcement?.title}</h4>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium border ${getPriorityColor(announcement?.priority)}`}>
                    {announcement?.priority}
                  </span>
                </div>
                <span className="text-xs text-muted-foreground">
                  {formatDate(announcement?.date)}
                </span>
              </div>
              
              <p className="text-sm text-muted-foreground mb-2">
                {announcement?.content}
              </p>
              
              <div className="flex items-center space-x-2">
                <Icon name="Tag" size={12} color="var(--color-muted-foreground)" />
                <span className="text-xs text-muted-foreground">{announcement?.type}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UpcomingHolidays;